var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.goHome}},[_c('img',{attrs:{"src":require("@/assets/TERM-VET-Logo-white.svg"),"alt":"TermVet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }